import { computed, type ComputedRef } from "vue";
import { useI18n } from "vue-i18n";
import { useSidebarStore } from "../../store/sidebar";

/** Разделы из подвала бокового меню — их нет в схеме навигации модуля. */
const FOOTER_TITLE_KEYS: Record<string, string> = {
  billing: "billing.sidebarLabel",
  personalization: "personalization.title",
  support: "main.support",
};

export interface MobileNavigation {
  /** Название текущего раздела для заголовка верхней панели. */
  currentTitle: ComputedRef<string>;
}

/**
 * Подпись текущего места в кабинете для шапки телефона (CAB-489).
 *
 * Берём её из той же схемы навигации, что и боковое меню: заголовок маршрута
 * для шапки не годится — он с хвостом «- Eplex» для вкладки браузера, а второй
 * список названий разошёлся бы с меню на первом же новом разделе.
 */
export function useMobileNavigation(): MobileNavigation {
  const { t } = useI18n();
  const store = useSidebarStore();

  const currentTitle = computed(() => {
    const config = store.activeModule ? store.modules[store.activeModule] : undefined;
    if (!config) return "";

    const all = [...(config.groups?.flatMap((group) => group.items) ?? []), ...(config.subSections ?? [])];
    const current = all.find((item) => item.id === store.activeSubModule);
    if (current) return current.name;

    // Разделы в подвале бокового меню в схему навигации не входят —
    // берём их подписи оттуда же, откуда берёт подвал.
    const footerKey = FOOTER_TITLE_KEYS[store.activeSubModule ?? ""];
    return footerKey ? t(footerKey) : config.name;
  });

  return { currentTitle };
}
